const hasCookieConsentLaunched = () => {
  const startDate = process.env.GATSBY_COOKIE_CONSENT_START_DATE
  if (!startDate) {
    return false
  }
  return new Date() >= new Date(startDate)
}

module.exports = { hasCookieConsentLaunched }
